import React, { useState } from "react";
import { GridCloseIcon } from "@mui/x-data-grid";
import Box from "components/common/Box";
import Drawer from "components/common/Drawer";
import IconButton from "components/common/IconButton";
import Text from "components/common/Text";
import FilterButton from "components/CommonDrawerFilter/FilterButton";
import Filter from "components/CommonDrawerFilter/Filter";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles(() => ({
  center:{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding:"10px"
  },
  draweritem:{
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    marginBottom: "24%",
  }
}));
const VehiclesDrawer = ({ drawerOpen, toggleDrawer, filters, applyFilter }) => {
  const classes = useStyles();
  const [filterData, setFilterData] = useState([]);
  const [filterbrands, setFilterBrands] = useState([]);
  const [evtype, setEvType] = useState([]);
  const [subtype, setSubType] = useState([]);
  const [model, setModel] = useState([]);
  const [variant, setVariant] = useState([]);
  const [ac, setAc] = useState([]);
  const [dc, setDc] = useState([]);
  const [clearfilter, setClearFilter] = useState(0);
  const handleClear = () => {
    const newFilterData = {
      manufacturer: [],
      manufacturer_type: [],
      sub_type: [],
      variant_name: [],
      model_name: [],
      ac_names: [],
      dc_names: [],
    };
    setFilterData([]);
    applyFilter(newFilterData);
    setClearFilter(clearfilter + 1);
    toggleDrawer(false);
  };

  const handleApply = () => {
    const newFilterData = {
      manufacturer: filterbrands?.selectedBrands,
      manufacturer_type: evtype?.selectedBrands,
      sub_type: subtype?.selectedBrands,
      variant_name: variant?.selectedBrands,
      model_name: model?.selectedBrands,
      ac_names: ac?.selectedBrands,
      dc_names: dc?.selectedBrands,
    };

    setFilterData(newFilterData);
    applyFilter(newFilterData);
    toggleDrawer(false);
  };

  return (
    <Drawer
      anchor="right"
      open={drawerOpen}
      onClose={() => toggleDrawer(false)}
    >
      <Box sx={{ width: 250 }} role="presentation">
        <Box className={classes.center}>
          <Text variant="h6">Filter</Text>
          <IconButton
            aria-label="close"
            onClick={() => toggleDrawer(false)}
            sx={{
              color: (theme) => theme.palette.grey[400],
            }}
          >
            <GridCloseIcon />
          </IconButton>
        </Box>
      </Box>
      <Box className={classes.draweritem}>
        {filters?.manufacturers && (
          <Filter
            data={filters?.manufacturers}
            filterData={filterData}
            filterType="Brand"
            searchkey={true}
            setFilterData={setFilterBrands}
            clearfilter={clearfilter}
            dataType="manufacturer"
          />
        )}

        {filters?.manufacturer_types && (
          <Filter
            filterData={filterData}
            data={filters?.manufacturer_types}
            filterType="EV Type"
            setFilterData={setEvType}
            clearfilter={clearfilter}
            dataType="manufacturer_type"
          />
        )}
        {filters?.sub_types && (
          <Filter
            filterData={filterData}
            data={filters?.sub_types}
            filterType="Sub Type"
            setFilterData={setSubType}
            clearfilter={clearfilter}
            dataType="sub_type"
          />
        )}
        {filters?.models && (
          <Filter
            filterData={filterData}
            data={filters?.models}
            filterType="Model"
            searchkey={true}
            setFilterData={setModel}
            clearfilter={clearfilter}
            dataType="model_name"
          />
        )}
        {filters?.variants && (
          <Filter
            filterData={filterData}
            data={filters?.variants}
            filterType="Variants"
            searchkey={true}
            setFilterData={setVariant}
            clearfilter={clearfilter}
            dataType="variant_name"
          />
        )}
        {filters?.ac_names && (
          <Filter
            filterData={filterData}
            data={filters?.ac_names}
            filterType="AC"
            searchkey={true}
            setFilterData={setAc}
            clearfilter={clearfilter}
            dataType="ac_names"
          />
        )}
        {filters?.dc_names && (
          <Filter
            allfileterdata={dc}
            filterData={filterData}
            data={filters?.dc_names}
            filterType="DC"
            setFilterData={setDc}
            searchkey={true}
            clearfilter={clearfilter}
            dataType="dc_names"
          />
        )}
        <Box>
          <FilterButton
            drawerOpen={drawerOpen}
            handleClear={handleClear}
            handleApply={handleApply}
          />
        </Box>
      </Box>
    </Drawer>
  );
};

export default VehiclesDrawer;
